import config from './config'

function getIncidents() {
  const incidents_url = `${config.API_HOST}/incidents`
  
  return fetch(incidents_url).then(response => response.json())
}

export default getIncidents